query sectionsFilter($scenarioId: ID!, $filterId: ID, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    sections(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        vacancies
        bundle {
          term {
            code
          }
        }
        course {
          id
          name
          code
          curriculum {
            id
            code
          }
        }
        schedule {
          resourceAssigment {
            schedule
          }
        }
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
    }
  }
}
